import { render } from "./AppExpendedTable.vue?vue&type=template&id=7ca5c8e5&scoped=true&ts=true"
import script from "./AppExpendedTable.vue?vue&type=script&lang=ts"
export * from "./AppExpendedTable.vue?vue&type=script&lang=ts"

import "./AppExpendedTable.vue?vue&type=style&index=0&id=7ca5c8e5&scoped=true&lang=css"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca5c8e5"]])

export default __exports__